// Čítanie natívneho HTML detailu — slovenské dvojča locale/cs/productPreviewModel.js
// (dev/sk/product.html: „Kategória", „Zvoľte variant").
export default {
  skipParamRe: /^kateg[oó]ri/i,
  variantPlaceholderRe: /zvo[lľ]te\s+(?:prosím\s+)?variant/i,
};
